export var edgeDeviceTextEnum;
(function (edgeDeviceTextEnum) {
    edgeDeviceTextEnum["IR809"] = "Cisco IR 809";
    edgeDeviceTextEnum["IR1101"] = "Cisco IR 1101";
    edgeDeviceTextEnum["EB_SUPER_HUB"] = "SuperHub";
})(edgeDeviceTextEnum || (edgeDeviceTextEnum = {}));
